import { useState } from 'react'

import { useMirohaToast } from 'src/lib/chakra-theme/components/toast/use-miroha-toast'
import useSWR from 'swr'

type Param = {
  roomUid: string
  participantUid: string
}

type VideoCallTokenState = {
  token: string | null
  videoCallUserUid: number | null
  screenShareUserUid: number | null
  screenShareToken: string | null
  agoraCloudProxyMode: 'Auto' | 'ForceUDP' | 'ForceTCP'
}

const initialState: VideoCallTokenState = {
  token: null,
  videoCallUserUid: null,
  screenShareUserUid: null,
  screenShareToken: null,
  agoraCloudProxyMode: 'Auto',
}

const fetcher = async (param: Param) => {
  const url = `${import.meta.env.VITE_SERVER_URL}/video_call_rooms/token`
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      roomUid: param.roomUid,
      participantUid: param.participantUid,
    }),
    credentials: 'include',
  })
  const body: {
    token: string
    videoCallUserUid: number
    screenShareUserUid: number
    screenShareToken: string
    agoraCloudProxyMode?: 'Auto' | 'ForceUDP' | 'ForceTCP'
  } = await response.json()
  return body
}

export const useVideoCallToken = (param: Param | null) => {
  const [state, setState] = useState<VideoCallTokenState>(initialState)
  const toast = useMirohaToast()

  useSWR(param, fetcher, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    onSuccess: data => {
      setState({
        token: data.token,
        videoCallUserUid: data.videoCallUserUid,
        screenShareUserUid: data.screenShareUserUid,
        screenShareToken: data.screenShareToken,
        agoraCloudProxyMode: data.agoraCloudProxyMode ?? 'Auto',
      })
    },
    onError: () => {
      toast({
        status: 'error',
        title: '問題が発生しました',
      })
    },
  })

  return state
}
